import styled from "styled-components"

export const Title = styled.div`
  font-size: 2em;
  font-weight: 400;
  margin-bottom: 1em;
`
